import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Department & Organization Module Service Stores
 */
export const departmentStores: ServiceStoreConfig[] = [
  {
    name: "departments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.departmentsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalDepartments = entities.length;
          const activeDepartments = entities.filter(
            (dept: Record<string, unknown>) => dept.isActive !== false
          ).length;
          const totalEmployees = entities.reduce(
            (sum: number, dept: Record<string, unknown>) => {
              return sum + ((dept.employeeCount as number) || 0);
            },
            0
          );
          const totalBudget = entities.reduce(
            (sum: number, dept: Record<string, unknown>) => {
              return sum + ((dept.budget as number) || 0);
            },
            0
          );

          return [
            {
              title: "Total Departments",
              value: () => totalDepartments.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeDepartments.toString(),
              valueColor: "success.main",
            },
            {
              title: "Total Employees",
              value: () => totalEmployees.toString(),
              valueColor: "info.main",
            },
            {
              title: "Total Budget",
              value: () => `$${((totalBudget as number) / 1000).toFixed(0)}K`,
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
    },
  },
  {
    name: "department-permissions",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "department-teams",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
];